import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import $ from "jquery";
// import QrCode from "../../../../images/qr_code.png";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';


const VerifyCorpPayment = ({ show, onClose , order }) => {

    const [cateringType, setCateringType] = useState([]);
    const [functionType, setFunctionType] = useState([]);
    const [mealsPeriod, setMealsPeriod] = useState([]);
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;

    const options_payment_mode = [
        { value: "1", label: "Paypal" },
        { value: "3", label: "Paytm" },
        { value: "4", label: "Google Pay" },
        { value: "5", label: "Bank" },
        { value: "6", label: "Cash" },
    ];

    const tableRef = useRef(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const [endDate, setEndDate] = useState(new Date()); 

    const [isVisible, setIsVisible] = useState();
    const handlePaymentModeChange = (selected) => {
        setSelectedOption(selected);
        setIsVisible(selected.value !== "6");
    };

    useEffect(() => {
        // Add 7 days to the current date
        const nextDate = new Date();
        nextDate.setDate(nextDate.getDate() + 7);
        setEndDate(nextDate);
    }, []);

         const fetchCateringType = async () => {
        try {
                const response = await axios.get(`${BaseUrl}/cateringtype/getactive`);
                if (response.data && Array.isArray(response.data)) {
                    const formatted = response.data.map(item => ({
                        value: String(item.sno),
                        label: item.catering_type
                    }));
                    setCateringType(formatted);
                    console.log(formatted);
                }
            } catch (error) {
                console.error('Failed to fetch Catering Type:', error);
                setCateringType([]);
            }
    };

    const getCateringTypeLabel = (sno) => {
        if (!Array.isArray(cateringType)) return '';
        const found = cateringType.find(ct => ct.value === String(sno));
        return found?.label || '';
    };

    const fetchitemSchedule = async () => {
            try {
                const response = await axios.get(`${BaseUrl}/item-schedule/items/active`);
                
                const list = response.data?.data;
        
                if (Array.isArray(list)) {
                const formatted = list.map(item => ({
                    value: String(item.sno),
                    label: item.itemschedule_name
                }));
                setMealsPeriod(formatted);
                } else {
                setMealsPeriod([]); // fallback to empty array
                }
            } catch (error) {
                console.error('Failed to fetch Meals period:', error);
                setMealsPeriod([]); // fallback to empty array, not object
            }
    };

    const getMealsPeriodLabel = (sno) => {
        if (!Array.isArray(mealsPeriod)) return '';
        const found = mealsPeriod.find(mp => mp.value === String(sno));
        return found?.label || '';
    };

    const fetchFunctionType = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/functiontype/getactive`);
            if (response.data && Array.isArray(response.data)) {
             const formatted = response.data.map(item => ({
                    value: String(item.sno),
                    label: item.function_type
                }));
                setFunctionType(formatted);
            }
        } catch (error) {
            console.error('Failed to Function Type:', error);
            setFunctionType([]);
        }
    };

    const getFunctionTypeLabel = (sno) => {
        if (!Array.isArray(functionType)) return '';
        const found = functionType.find(ft => ft.value === String(sno));
        return found?.label || '';
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    
    const user_id = parseInt(localStorage.getItem("user_id"), 10);
    const verifyPayment = async (order) => {
        if (!order) {
            toast.error("Invalid order or missing payment ID.");
            return;
        }

        try {
            const response = await axios.post(`${BaseUrl}/manage_corporate_order/verify_payment`, {
                params: {
                    order: order, 
                    user_id : user_id,
                },
            });

            if (response.data?.success) {
                toast.success(response.data.message || "Payment Verified Successfully");
                onClose();
            } else {
                toast.error(response.data?.message || "Verification failed.");
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to Verify Payment");
            console.error("Failed to Verify Payment:", error);
        }
    };

   useEffect(() => {
                    fetchFunctionType();
                    fetchCateringType();
                    fetchitemSchedule();
            }, []);



    useEffect(() => {
        const tables = document.querySelectorAll('.subscription_table');
        tables.forEach((table) => {
            if (!$.fn.dataTable.isDataTable(table)) {
                $(table).DataTable({
                    "responsive": true,
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        });
    }, []);
    const [showPaymentDetails, setShowPaymentDetails] = useState(false);
    const [sendVia, setSendVia] = useState('');

    const handleSendViaChange = (e) => {
        setSendVia(e.target.value);
    };


    return (
        <Modal show={show} size="lg"  >
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Verify Payment</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                  <div className="modal-body">
                    <div className="row mb-4">
                        {/* Order Id */}
                        <div className="col-lg-4 d-flex flex-column align-items-start gap-1 mb-2">
                        <label className="text-black font-w600 fs-7" htmlFor="orderId">
                            Order Id
                        </label>
                        <div id="orderId" className="d-block">
                            <label className="text-danger font-w600 fs-6 py-0">
                            {order?.corp_orders?.[0]?.catering_id || "-"}
                            </label>
                        </div>
                        </div>

                        {/* Customer Name */}
                        <div className="col-lg-4 d-flex flex-column align-items-start gap-1 mb-2">
                        <label className="text-black font-w600 fs-7" htmlFor="customerName">
                            Customer Name
                        </label>
                        <div id="customerName" className="d-block">
                            <label className="text-danger font-w600 fs-6 py-0">
                            {order?.corp_customer?.customer_name || "-"}
                            </label>
                        </div>
                        </div>

                        {/* Customer Mobile No */}
                        <div className="col-lg-4 d-flex flex-column align-items-start gap-1 mb-2">
                        <label className="text-black font-w600 fs-7" htmlFor="customerMobile">
                            Customer Mobile No
                        </label>
                        <div id="customerMobile" className="d-block">
                            <label className="text-danger font-w600 fs-6 py-0">
                            {order?.corp_customer?.customer_number || "-"}
                            </label>
                        </div>
                        </div>

                        {/* Catering Type */}
                        <div className="col-lg-4 d-flex flex-column align-items-start gap-1 mb-2">
                        <label className="text-black font-w600 fs-7" htmlFor="cateringType">
                            Catering Type
                        </label>
                        <div id="cateringType" className="d-block">
                            <label className="text-danger font-w600 fs-6 py-0">
                            {getCateringTypeLabel(order?.corp_orders?.[0]?.catering_type)}
                            </label>
                        </div>
                        </div>

                        {/* Total Cost */}
                        <div className="col-lg-4 d-flex flex-column align-items-start gap-1 mb-2">
                        <label className="text-black font-w600 fs-7" htmlFor="totalCost">
                            Total Cost
                        </label>
                        <div id="totalCost" className="d-block">
                            <label className="text-danger font-w600 fs-6 py-0">
                            ₹ {order?.corp_orders?.[0]?.total || "0"}
                            </label>
                        </div>
                        </div>

                        {/* Order Date */}
                        <div className="col-lg-4 d-flex flex-column align-items-start gap-1 mb-2">
                        <label className="text-black font-w600 fs-7" htmlFor="orderDate">
                            Order Date
                        </label>
                        <div id="orderDate" className="d-block">
                            <label className="text-danger font-w600 fs-6 py-0">
                            {formatDate(order?.corp_orders?.[0]?.order_date)}
                            </label>
                        </div>
                        </div>
                    </div>

                    <div className="row mb-4">
                        <div className="col-lg-6 mb-2">
                        <div className="row">
                            {/* Transaction Date */}
                            <div className="col-lg-12 d-flex justify-content-between align-items-center mb-2">
                            <label className="text-black font-w600 fs-7" htmlFor="transactionDate">
                                Transaction Date
                            </label>
                            <label
                                id="transactionDate"
                                className="text-primary font-w600 fs-6 py-0"
                            >
                                {formatDate(order?.initialPayDate)}
                            </label>
                            </div>

                            {/* Credit Amount */}
                            <div className="col-lg-12 d-flex justify-content-between align-items-center mb-2">
                            <label className="text-black font-w600 fs-7" htmlFor="creditAmount">
                                Credit Amount
                            </label>
                            <label id="creditAmount" className="text-primary font-w600 fs-6 py-0">
                                ₹ {order?.amount || 0}
                            </label>
                            </div>

                            {/* Payment ID */}
                            <div className="col-lg-12 d-flex justify-content-between align-items-center mb-2">
                            <label className="text-black font-w600 fs-7" htmlFor="paymentId">
                                Payment ID
                            </label>
                            <label id="paymentId" className="text-primary font-w600 fs-6 py-0">
                                {order?.payment_id || "-"}
                            </label>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                        <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={() => verifyPayment(order)}
                        aria-label="Verify Payment"
                        >
                        Verify <i className="fas fa-angle-double-right ms-2"></i>
                        </button>
                    </div>
                    </div>

            </div>
        </Modal>
    );
};

export default VerifyCorpPayment;
